import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
// import { Manager, Target, Popper } from "react-popper";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody";
import MobileNavbar from "componentsCustom/Navbars/MobileNavbar.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";

import LanguageSelector from "container/componentsCustom/LanguageSelectorContainer.js";
// import CurrencySelector from "container/componentsCustom/CurrencySelectorContainer.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.js";
import {
  warningColor,
  hexToRgb
} from "assets/jss/material-dashboard-pro-react.js";

const useStyles = makeStyles(styles);

export default function SidebarMobile(props) {
  const { t } = useTranslation();

  // const [cartCounter, setCartCounter] = useState(0);

  const classes = useStyles();
  const {
    rtlActive,
    cart,
    handleDrawerToggle,
    language,
    currency,
    logo,
    webLink,
    // restaurant,
    customStyle,
    // shippingInfo,
    cartParams,
    museum
  } = props;

  const {
    // totalPrice,
    // servicesFees,
    // deliveryCost,
    // total,
    cartCounter,
    totToShow
  } = cartParams;

  // const tot = totalPrice === 0 ? 0 : total;

  return (
    <div className={classes.sidebarContainer}>
      <MobileNavbar
        brandText={"sidebar"}
        handleDrawerToggle={handleDrawerToggle}
        cart={cart}
        language={language}
        logo={logo}
        webLink={webLink}
      />
      <MobileWrapper
        type={"sidebar"}
        containerClasses={classes.transparentStyle}
      >
        <CardBody style={{ marginTop: "30px" }}>
          <div className={classes.content}>
            {/* <div className={classes.container}> */}
            <span className={classes.title}>{t("cart.menu")}</span>
            <Card className={classes.card}>
              <Link to={`/${museum?.identificativo}/contacts`} className={classes.linkCart}>
                <div
                  style={{ display: "contents" }}
                  onClick={() => handleDrawerToggle()}
                >
                  <GridContainer>
                    <GridItem xs={6} sm={6} md={6} lg={6}>
                      <span className={classes.cartName}>
                        <span style={{ paddingRight: "2px" }}>
                          {currency && currency.symbol ? currency.symbol : ""}
                        </span>
                        {totToShow.toFixed(2)}
                      </span>
                    </GridItem>
                    <GridItem xs={6} sm={6} md={6} lg={6}>
                      <div className={classes.containerNavCart}>
                        {cartCounter && cartCounter > 0 ? (
                          // <span className={'notifications'}>{cartCounter}</span>
                          <span>
                            <span className={classes.notifications}>
                              <span style={{ lineHeight: "18px" }}>
                                {cartCounter}
                              </span>
                            </span>
                          </span>
                        ) : null}
                        <div
                          style={{
                            display: "inline-block"
                          }}
                        >
                          <ShoppingBasketIcon
                            className={
                              classes.headerLinksSvg +
                              " " +
                              (rtlActive
                                ? classes.links + " " + classes.linksRTL
                                : classes.links)
                            }
                            style={{
                              color:
                                "rgba(" +
                                hexToRgb(
                                  customStyle.buttonCart || warningColor[0]
                                ) +
                                ", 0.7)"
                            }}
                          />
                        </div>
                      </div>
                    </GridItem>
                  </GridContainer>
                </div>
              </Link>
            </Card>
            <LanguageSelector
              classContainer="language-selector-header"
              color="#4a4a4a"
            />
            {/* <CurrencySelector /> */}
            {/* </div> */}
          </div>
        </CardBody>
      </MobileWrapper>
    </div>
  );
}

SidebarMobile.propTypes = {
  rtlActive: PropTypes.bool,
  cart: PropTypes.arrayOf(PropTypes.object).isRequired,
  language: PropTypes.string.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string
  }).isRequired,
  shippingInfo: PropTypes.shape({
    type: PropTypes.string
  }).isRequired,
  logo: PropTypes.string,
  webLink: PropTypes.string,
  restaurant: PropTypes.object.isRequired,
  customStyle: PropTypes.object.isRequired,
  cartParams: PropTypes.shape({
    totalPrice: PropTypes.number,
    deliveryCost: PropTypes.number,
    servicesFees: PropTypes.number,
    total: PropTypes.number,
    cartCounter: PropTypes.number,
    totToShow: PropTypes.number
  }).isRequired
  // cart: PropTypes.arrayOf(PropTypes.any).isRequired
};

SidebarMobile.defaultProps = {
  logo: "",
  webLink: "",
  customStyle: {}
};
